<!--
 * @Author: your name
 * @Date: 2022-03-30 17:45:29
 * @LastEditTime: 2022-04-06 15:44:15
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\views\Case.vue
-->
<template>
  <div class="case">
    <div class="para">
      <div class="tit">合作企业</div>
      <div class="txt">
        本公司目前已与代表性工业客户：奇美集团、富士康集团、正隆集团、六和集团、英诺赛克半导体、苏州步步高互联网软件、南通阳鸿石化、泰兴省级化工园区、苏州博众精工科技、宝时得科技、江苏宜美科技无尘室厂房、尚宝泰机械、苏州赛众、南海奇美、济川药业、长澳制药、海纳制药、焦点生物、瑞邦生物科技、米巴精密零部件、安特精密机械技术、巨翊医疗科技、优泰克、苏州新纶超净技术、苏瑞膜纳米、台容电子、泰马克精密铸造、泰州龙洋智能科技；代表性民用公建客户：苏高新集团、苏高新股价、苏州城投公司、苏州保泽公司、园区新建元集团、园区重建公司、园区恒泰集团、相城城投公司、吴中城建公司、远洋地产、保利地产、金地地产；代表性总承包单位：中建一、三、四、八局、江苏永泰、南通光华、南通新华、中亿丰、苏州一建、嘉盛建设、通州建总等公司建立了长期合作关系。我们将以专业的技术、真诚的态度为相关单位提供优质周到的服务。
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">业绩图片</div>
      <div class="imgs">
          <img v-for="i in 23" :class="'pic'+i" :key="i" :src="require('../assets/images/y'+i+'.jpg')" />
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">业绩视频</div>
      <div class="imgs">
          <!-- <img v-for="i in 16" :class="'pic'+i" :key="i" :src="require('../assets/images/y'+i+'.jpg')" /> -->
          <VideoShow />
      </div>
    </div>
    <Root />
  </div>
</template>

<script>
import Root from '@/components/Root.vue'
import VideoShow from "../components/VideoShow.vue";
export default {
  name: "Case",
  components:{
      Root,
      VideoShow
  }
};
</script>

<style lang="less" scoped>
.para {
  padding: 1rem 20% 1rem 20%;
  display: inline-block;
  width: 100%;
}
.tit {
  font-size: 1.5rem;
  color: rgb(27, 151, 243);
  border-left: 5px solid rgb(27, 151, 243);
  padding-left: 0.5rem;
  font-weight: bold;
  text-align: left;
  margin-bottom:0.5rem;
}
.txt{
    text-align: left;
}
.imgs img{
    width:50%;
    height:30rem;
}
.imgs img.pic1,
.imgs img.pic2,
.imgs img.pic3,
.imgs img.pic16,
.imgs img.pic19,
.imgs img.pic20,
.imgs img.pic21{
    width:100%;
}
</style>